import { render } from "./no-found.vue?vue&type=template&id=874a4b36"
import script from "./no-found.vue?vue&type=script&lang=js"
export * from "./no-found.vue?vue&type=script&lang=js"

import exportComponent from "/studio/gordon/Studio/mylink-intgr/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__